import BaseService from "../baseService";
class LayoutXml extends BaseService {
  constructor(id) {
    const resource = "layout-nota";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new LayoutXml(id);
